import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';
import ArquivoInput from './arquivoInput';
import { baixarBlob } from './ferramentasUtils';

export default () => {
    const [arquivo, setArquivo] = useState(null);
    const [ordem, setOrdem] = useState('');
    const [status, setStatus] = useState('Selecione um PDF para reorganizar.');
    const carregar = async selecionado => {
        setArquivo(selecionado);
        if (!selecionado) return;
        try {
            const pdf = await PDFDocument.load(await selecionado.arrayBuffer());
            setOrdem(Array.from({ length: pdf.getPageCount() }, (_, i) => i + 1).join(', '));
            setStatus(`${pdf.getPageCount()} página(s) encontrada(s).`);
        } catch (ex) { setStatus(`PDF inválido: ${ex.message}`); }
    };
    const executar = async () => {
        try {
            if (!arquivo) throw new Error('Selecione um PDF.');
            const origem = await PDFDocument.load(await arquivo.arrayBuffer());
            const indices = ordem.split(',').map(item => Number(item.trim()) - 1);
            if (!indices.length || indices.some(item => !Number.isInteger(item) ||
                item < 0 || item >= origem.getPageCount())) {
                throw new Error('Informe números de páginas válidos, separados por vírgula.');
            }
            const destino = await PDFDocument.create();
            const paginas = await destino.copyPages(origem, indices);
            paginas.forEach(pagina => destino.addPage(pagina));
            baixarBlob(new Blob([await destino.save()], { type: 'application/pdf' }),
                'relatorio_reorganizado.pdf');
            setStatus('PDF reorganizado com sucesso.');
        } catch (ex) { setStatus(ex.message); }
    };
    return <div>
        <ArquivoInput label='Relatório em PDF' accept='.pdf'
            onChange={arquivos => carregar(arquivos[0])} />
        <div className='form-group'><label>Ordem das páginas</label>
            <input className='form-control' value={ordem}
                onChange={e => setOrdem(e.target.value)} placeholder='Ex.: 1, 3, 2, 4' />
            <small className='form-text text-muted'>Também é possível repetir ou remover páginas.</small>
        </div>
        <button className='btn btn-success' type='button' onClick={executar}>
            Reorganizar e baixar PDF
        </button>
        <div className='alert alert-light mt-3'>{status}</div>
    </div>;
};
